import { AppBarStickyState, DisplayState } from 'page-context/scrollStickyStateProvider/stickybar-types.js';
import { pathToRegexp } from 'path-to-regexp';
import { Pages } from 'utilities/router/api-fetch-path.js';

/**
 * Looks for a segment of the URL that starts with a forward slash (/), followed by any characters (representing the section)
 * and optionally followed by any other characters. The captured section is stored in a variable named section.
 * Verifies if the URL starts with the section.
 */
export const isSectionUrl = ({ currentUrl, linkUrl }: { currentUrl: string; linkUrl: string }): boolean => {
  if (linkUrl === Pages.ROOT) {
    return currentUrl === linkUrl;
  }
  const currentPath = currentUrl === Pages.ROOT ? Pages.HOME : currentUrl;
  const regexp = pathToRegexp('/:section/(.*)?');
  const [, section] = regexp.exec(currentPath) || [];
  return linkUrl.indexOf(`/${section}`) === 0;
};

export const getShouldDisplaySticky = (stickyItemsState: AppBarStickyState | undefined) => {
  if (stickyItemsState?.displayAsSticky === DisplayState.display) {
    return true;
  }
  if (stickyItemsState?.displayForced === DisplayState.display) {
    return true;
  }
  return false;
};
